/* eslint-disable */
import { RA_STEPS_IDENTIFIERS, initialRaSteps } from "../constants";

export const stepsHandler = (state, currentStep, readOnlyState) => {
  const editPhase = localStorage.getItem("chooseRetirement");
  const isEditStillOn = localStorage.getItem("isEditStillOn");
  switch (currentStep) {
    case RA_STEPS_IDENTIFIERS.RA_APPLICATION_WAKE_UP_INFO:
      state.steps = initialRaSteps;

      const isWakeUpSuccess =
        state.patchData.currentStep ===
          RA_STEPS_IDENTIFIERS.RA_APPLICATION_WAKE_UP_INFO &&
        state.patchData.message === "Success";

      const isSubmittedAndSuccess =
        state.data.applicationSubmitted === true &&
        state.patchData.currentStep ===
          RA_STEPS_IDENTIFIERS.RA_APPLICATION_SUCCESS;

      if (isSubmittedAndSuccess) {
        state.applicationSteps.isShowBeforeStart = true;
      } else {
        state.applicationSteps.isShowBeforeStart = !isWakeUpSuccess;
      }
      break;

    case RA_STEPS_IDENTIFIERS.RA_PENSION_WISE:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }
      state.applicationSteps.isPensionWise = false;
      if (state.throughEditButton) {
        state.applicationSteps.isConfirmDeclaration = true;
        StepIdentifier(state.steps, 11, state.throughEditButton);
      } else {
        StepIdentifier(state.steps, 11);
      }
      break;
    case RA_STEPS_IDENTIFIERS.RA_LUMP_SUM_ALLOWANCES:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }
      if (state.throughEditButton) {
        state.applicationSteps.isConfirmDeclaration = true;
        StepIdentifier(state.steps, 21, state.throughEditButton);
      } else {
        StepIdentifier(state.steps, 21);
      }
      break;
    case RA_STEPS_IDENTIFIERS.RA_POT_SELECTION:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }
      state.applicationSteps.isRetirementChoice = true;
      StepIdentifier(state.steps, 31);
      break;
    case RA_STEPS_IDENTIFIERS.RA_RETIREMENT_CHOICE:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }

      if (state.chooseRetirementSteps.isTakeMoneyInOneGo) {
        state.applicationSteps.isConfirmChoice = true;
      } else if (state.chooseRetirementSteps.isTakeTaxFreeCashInvestRest) {
        state.applicationSteps.isTakeTaxFreeCashInvestRest = true;
      } else if (state.chooseRetirementSteps.isTakeMoneyInOneChunk) {
        state.applicationSteps.isTakeMoneyInOneChunk = true;
      } else if (state.chooseRetirementSteps.isAnnuityHowMuchCash) {
        state.applicationSteps.isAnnuityHowMuchCash = true;
      } else if (state.chooseRetirementSteps.isRegularHowMuchCash) {
        state.applicationSteps.isRegularHowMuchCash = true;
      } else if (state.chooseRetirementSteps.isMixMatchHowMuchCash) {
        state.applicationSteps.isMixMatchHowMuchCash = true;
      }

      StepIdentifier(state.steps, 32);
      break;
    case RA_STEPS_IDENTIFIERS.RA_TAKE_ALL_IN_ONE_GO:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }
      if (state.chooseRetirementSteps.isTakeMoneyInOneGo) {
        if (
          readOnlyState?.choiceCategory?.moreContribution &&
          !state?.throughGetAPI
        ) {
          state.applicationSteps.isContribution = true;
          StepIdentifier(state.steps, 33);
        } else if (state?.throughGetAPI) {
          if (isEditStillOn) {
            state.applicationSteps.isConfirmDeclaration = true;
            StepIdentifier(state.steps, 33, isEditStillOn);
            StepIdentifier(state.steps, 34, isEditStillOn);
            localStorage.removeItem("isEditStillOn");
          } else {
            StepIdentifier(state.steps, 33);
            StepIdentifier(state.steps, 34);
          }
          state.throughGetAPI = false;
        } else {
          if (isEditStillOn) {
            state.applicationSteps.isConfirmDeclaration = true;
            StepIdentifier(state.steps, 33, isEditStillOn);
            localStorage.removeItem("chooseRetirement");
          } else {
            StepIdentifier(state.steps, 33);
          }
          state.throughGetAPI = false;
        }
      }
      break;
    case RA_STEPS_IDENTIFIERS.RA_TAX_FREE_CASH:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }
      if (state?.chooseRetirementSteps?.asLumpSum) {
        state.applicationSteps.isInvestRest = true;
        StepIdentifier(state.steps, 33);
      } else {
        state.applicationSteps.isConfirmChoice = true;
        StepIdentifier(state.steps, 33);
      }
      break;
    //for as a lump sum only - starts
    case RA_STEPS_IDENTIFIERS.RA_INVEST_THE_REST:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }
      if (state?.throughGetAPI && !(editPhase === "ChooseYourRetirement")) {
        if (isEditStillOn) {
          state.applicationSteps.isConfirmDeclaration = true;
          StepIdentifier(state.steps, 34, isEditStillOn);
          StepIdentifier(state.steps, 35, isEditStillOn);
          StepIdentifier(state.steps, 36, isEditStillOn);
          localStorage.removeItem("isEditStillOn");
        } else {
          StepIdentifier(state.steps, 34);
          StepIdentifier(state.steps, 35);
          StepIdentifier(state.steps, 36);
        }
        state.throughGetAPI = false;
      } else {
        state.applicationSteps.isConfirmChoice = true;
        StepIdentifier(state.steps, 34);
      }
      break;
    //for as a lump sum only - ends
    case RA_STEPS_IDENTIFIERS.RA_TAKE_MONEY_IN_CHUNKS:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }
      if (state.chooseRetirementSteps.isTakeMoneyInOneChunk) {
        if (state?.throughGetAPI && !(editPhase === "ChooseYourRetirement")) {
          if (isEditStillOn) {
            state.applicationSteps.isConfirmDeclaration = true;
            StepIdentifier(state.steps, 34, isEditStillOn);
            StepIdentifier(state.steps, 35, isEditStillOn);
            localStorage.removeItem("isEditStillOn");
          } else {
            StepIdentifier(state.steps, 34);
            StepIdentifier(state.steps, 35);
          }
          state.throughGetAPI = false;
        } else {
          state.applicationSteps.isConfirmChoice = true;
          StepIdentifier(state.steps, 33);
        }
      }
      break;
    case RA_STEPS_IDENTIFIERS.RA_ANNUITY_CHOICE:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }
      state.applicationSteps.isAnnuity = true;
      StepIdentifier(state.steps, 33);
      break;
    case RA_STEPS_IDENTIFIERS.RA_ANNUITY_PROVIDER:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }
      if (state.chooseRetirementSteps.isAnnuityHowMuchCash) {
        if (state?.throughGetAPI && !(editPhase === "ChooseYourRetirement")) {
          if (isEditStillOn) {
            state.applicationSteps.isConfirmDeclaration = true;
            StepIdentifier(state.steps, 35, isEditStillOn);
            StepIdentifier(state.steps, 36, isEditStillOn);
            localStorage.removeItem("isEditStillOn");
          } else {
            StepIdentifier(state.steps, 35);
            StepIdentifier(state.steps, 36);
          }
          state.throughGetAPI = false;
        } else {
          state.applicationSteps.isConfirmChoice = true;
          StepIdentifier(state.steps, 34);
        }
      }
      break;

    case RA_STEPS_IDENTIFIERS.RA_RI_CASH_LUMPSUM:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }
      state.applicationSteps.isTakingRegularIncome = true;
      StepIdentifier(state.steps, 33);
      break;
    case RA_STEPS_IDENTIFIERS.RA_RI_INVEST_THE_REST:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }
      if (state.chooseRetirementSteps.isRegularHowMuchCash) {
        if (state?.throughGetAPI && !(editPhase === "ChooseYourRetirement")) {
          if (isEditStillOn) {
            state.applicationSteps.isConfirmDeclaration = true;
            StepIdentifier(state.steps, 36, isEditStillOn);
            StepIdentifier(state.steps, 37, isEditStillOn);
            localStorage.removeItem("isEditStillOn");
          } else {
            StepIdentifier(state.steps, 36);
            StepIdentifier(state.steps, 37);
          }
          state.throughGetAPI = false;
        } else {
          state.applicationSteps.isConfirmChoice = true;
          StepIdentifier(state.steps, 34);
        }
      }
      break;

    case RA_STEPS_IDENTIFIERS.RA_MM_CASH_LUMPSUM:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }
      state.applicationSteps.isMixandMatch = true;
      StepIdentifier(state.steps, 33);
      break;
    case RA_STEPS_IDENTIFIERS.RA_BEND_STRATEGIES:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }
      if (state?.throughGetAPI && !(editPhase === "ChooseYourRetirement")) {
        if (isEditStillOn) {
          state.applicationSteps.isConfirmDeclaration = true;
          StepIdentifier(state.steps, 36, isEditStillOn);
          StepIdentifier(state.steps, 37, isEditStillOn);
          localStorage.removeItem("isEditStillOn");
        } else {
          StepIdentifier(state.steps, 36);
          StepIdentifier(state.steps, 37);
        }
        state.throughGetAPI = false;
      } else {
        state.applicationSteps.isConfirmChoice = true;
        StepIdentifier(state.steps, 34);
      }
      break;
    case RA_STEPS_IDENTIFIERS.RA_CONTRIBUTION:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }
      if (state.chooseRetirementSteps.isTakeMoneyInOneGo) {
        if (editPhase === "ChooseYourRetirement") {
          state.applicationSteps.isConfirmDeclaration = true;
          StepIdentifier(state.steps, 34, state.throughEditButton);
          localStorage.removeItem("chooseRetirement");
        } else {
          StepIdentifier(state.steps, 34);
        }
      } else if (state.chooseRetirementSteps.isTakeTaxFreeCashInvestRest) {
        if (editPhase === "ChooseYourRetirement") {
          state.applicationSteps.isConfirmDeclaration = true;
          StepIdentifier(state.steps, 36, state.throughEditButton);
          localStorage.removeItem("chooseRetirement");
        } else {
          StepIdentifier(state.steps, 36);
        }
      } else if (state.chooseRetirementSteps.isAnnuityHowMuchCash) {
        if (editPhase === "ChooseYourRetirement") {
          state.applicationSteps.isConfirmDeclaration = true;
          StepIdentifier(state.steps, 36, state.throughEditButton);
          localStorage.removeItem("chooseRetirement");
        } else {
          StepIdentifier(state.steps, 36);
        }
      } else if (state.chooseRetirementSteps.isTakeMoneyInOneChunk) {
        if (editPhase === "ChooseYourRetirement") {
          state.applicationSteps.isConfirmDeclaration = true;
          StepIdentifier(state.steps, 35, state.throughEditButton);
          localStorage.removeItem("chooseRetirement");
        } else {
          StepIdentifier(state.steps, 35);
        }
      } else if (state.chooseRetirementSteps.isRegularHowMuchCash) {
        state.applicationSteps.isIllustration = true;
        StepIdentifier(state.steps, 36);
      } else if (state.chooseRetirementSteps.isMixMatchHowMuchCash) {
        state.applicationSteps.isIllustration = true;
        StepIdentifier(state.steps, 36);
      }
      break;
    case RA_STEPS_IDENTIFIERS.RA_CONFIRM_CHOICE:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }
      if (state.chooseRetirementSteps.isTakeMoneyInOneGo) {
        if (readOnlyState?.choiceCategory?.moreContribution) {
          state.applicationSteps.isContribution = true;
          StepIdentifier(state.steps, 33);
        } else {
          StepIdentifier(state.steps, 33);
        }
      } else if (state.chooseRetirementSteps.isTakeTaxFreeCashInvestRest) {
        if (readOnlyState?.choiceCategory?.moreContribution) {
          state.applicationSteps.isContribution = true;
          StepIdentifier(state.steps, 35);
        } else if (state?.taxFreeCashAsLumpSumChosen) {
          if (editPhase === "ChooseYourRetirement") {
            state.applicationSteps.isConfirmDeclaration = true;
            StepIdentifier(state.steps, 35, state.throughEditButton);
            localStorage.removeItem("chooseRetirement");
          } else {
            StepIdentifier(state.steps, 35);
          }
        } else {
          if (editPhase === "ChooseYourRetirement") {
            state.applicationSteps.isConfirmDeclaration = true;
            StepIdentifier(state.steps, 34, state.throughEditButton);
            localStorage.removeItem("chooseRetirement");
          } else {
            StepIdentifier(state.steps, 34);
          }
        }
      } else if (state.chooseRetirementSteps.isTakeMoneyInOneChunk) {
        if (readOnlyState?.choiceCategory?.moreContribution) {
          state.applicationSteps.isContribution = true;
          StepIdentifier(state.steps, 34);
        } else {
          if (editPhase === "ChooseYourRetirement") {
            state.applicationSteps.isConfirmDeclaration = true;
            StepIdentifier(state.steps, 34, state.throughEditButton);
            localStorage.removeItem("chooseRetirement");
          } else {
            StepIdentifier(state.steps, 34);
          }
        }
      } else if (state.chooseRetirementSteps.isAnnuityHowMuchCash) {
        if (readOnlyState?.choiceCategory?.moreContribution) {
          state.applicationSteps.isContribution = true;
          StepIdentifier(state.steps, 35);
        } else {
          if (editPhase === "ChooseYourRetirement") {
            state.applicationSteps.isConfirmDeclaration = true;
            StepIdentifier(state.steps, 35, state.throughEditButton);
            localStorage.removeItem("chooseRetirement");
          } else {
            StepIdentifier(state.steps, 35);
          }
        }
      } else if (state.chooseRetirementSteps.isRegularHowMuchCash) {
        if (readOnlyState?.choiceCategory?.moreContribution) {
          state.applicationSteps.isContribution = true;
          StepIdentifier(state.steps, 35);
        } else {
          state.applicationSteps.isIllustration = true;
          StepIdentifier(state.steps, 35);
        }
      } else if (state.chooseRetirementSteps.isMixMatchHowMuchCash) {
        if (readOnlyState?.choiceCategory?.moreContribution) {
          state.applicationSteps.isContribution = true;
          StepIdentifier(state.steps, 35);
        } else {
          state.applicationSteps.isIllustration = true;
          StepIdentifier(state.steps, 35);
        }
      }
      break;
    case RA_STEPS_IDENTIFIERS.BANK_MANDATE:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }

      StepIdentifier(state.steps, 41);

      state.applicationSteps.isBankMandateConfirm = true;

      break;
    case RA_STEPS_IDENTIFIERS.BANK_MANDATE_CONFIRM:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }
      if (state.throughEditButton) {
        state.applicationSteps.isIdv = false;
        let bankMandateEdit = true;
        StepIdentifier(
          state.steps,
          42,
          state.throughEditButton,
          bankMandateEdit
        );
        bankMandateEdit = false;
      } else {
        StepIdentifier(state.steps, 42);
      }

      break;
    case RA_STEPS_IDENTIFIERS.RA_ILLUSTRATION:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }
      if (
        state.chooseRetirementSteps.isRegularHowMuchCash ||
        state.chooseRetirementSteps.isMixMatchHowMuchCash
      ) {
        if (readOnlyState?.choiceCategory?.moreContribution) {
          if (editPhase === "ChooseYourRetirement") {
            state.applicationSteps.isConfirmDeclaration = true;
            StepIdentifier(state.steps, 37, state.throughEditButton);
            localStorage.removeItem("chooseRetirement");
          } else {
            StepIdentifier(state.steps, 37);
          }
        } else {
          if (editPhase === "ChooseYourRetirement") {
            state.applicationSteps.isConfirmDeclaration = true;
            StepIdentifier(state.steps, 36, state.throughEditButton);
            localStorage.removeItem("chooseRetirement");
          } else {
            StepIdentifier(state.steps, 36);
          }
        }
      }

      break;
    case RA_STEPS_IDENTIFIERS.RA_IDENTITY_AND_VERIFICATION:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }

      StepIdentifier(state.steps, 51);

      break;
    case RA_STEPS_IDENTIFIERS.DECLARATION:
      for (const key in state.applicationSteps) {
        if (
          state.applicationSteps.hasOwnProperty.call(
            state.applicationSteps,
            key,
          )
        ) {
          state.applicationSteps[key] = false;
        }
      }

      StepIdentifier(state.steps, 61);
      state.applicationSteps.isDeclaration = true;

      break;
    case RA_STEPS_IDENTIFIERS.RA_APPLICATION_SUCCESS:
      StepIdentifier(state.steps, 62);

      break;
    default:
      break;
  }
};
export function completeSubStep(
  steps,
  mainStepIndex,
  subStepIndex,
  throughEditButton,
  bankMandate
) {
  const mainStep = steps[mainStepIndex];
  for (let i = 0; i <= subStepIndex; i++) {
    const subStep = mainStep.subSteps[i];
    subStep.isSubComplete = true;
    subStep.isSubBegin = false;
    subStep.isSubUpComing = false;
  }

  if (subStepIndex + 1 < mainStep.subSteps.length) {
    mainStep.subSteps[subStepIndex + 1].isSubBegin = true;
    mainStep.subSteps[subStepIndex + 1].isSubUpComing = false;
    mainStep.isSubStepsOpen = true;
  } else {
    mainStep.isSubStepsOpen = false;
    mainStep.isComplete = true;
    mainStep.isBegin = false;
    mainStep.isUpComing = false;

    if (mainStepIndex + 1 < steps.length) {
      const nextMainStep = steps[mainStepIndex + 1];
      if (!throughEditButton || bankMandate) {
        nextMainStep.isBegin = true;
      }
      nextMainStep.isUpComing = false;

      if (nextMainStep.subSteps.length > 0) {
        nextMainStep.subSteps[0].isSubBegin = true;
        nextMainStep.subSteps[0].isSubUpComing = false;
      }
    }
  }
}

export function completeMainStep(steps, mainStepIndex, throughEditButton) {
  const mainStep = steps[mainStepIndex];
  mainStep.isComplete = true;
  mainStep.isBegin = false;
  mainStep.isUpComing = false;
  mainStep.isSubStepsOpen = false;

  if (!throughEditButton) {
    if (mainStepIndex + 1 < steps.length) {
      const nextMainStep = steps[mainStepIndex + 1];
      nextMainStep.isBegin = true;
      nextMainStep.isUpComing = false;

      if (nextMainStep.subSteps.length > 0) {
        nextMainStep.subSteps[0].isSubBegin = true;
        nextMainStep.subSteps[0].isSubUpComing = false;
      }
    }
  } 
}

export function StepIdentifier(
  raSteps,
  subStepNo,
  throughEditButton,
  bankMandate
) {
  for (let mainStepIndex = 0; mainStepIndex < raSteps.length; mainStepIndex++) {
    const mainStep = raSteps[mainStepIndex];
    const subStepIndex = mainStep.subSteps.findIndex(
      (subStep) => subStep.sequence === subStepNo,
    );

    if (subStepIndex !== -1) {
      // Mark all previous main steps as complete
      for (let i = 0; i < mainStepIndex; i++) {
        completeMainStep(raSteps, i, throughEditButton, bankMandate);
      }

      completeSubStep(raSteps, mainStepIndex, subStepIndex, throughEditButton, bankMandate);
      return;
    }
  }
}

export function backButtonHandler(raSteps, subStepNo) {
  for (let mainStepIndex = 0; mainStepIndex < raSteps.length; mainStepIndex++) {
    const mainStep = raSteps[mainStepIndex];
    const subStepIndex = mainStep.subSteps.findIndex(
      (subStep) => subStep.sequence === subStepNo,
    );
    if (subStepIndex !== -1) {
      if (subStepIndex > 0) {
        const previousSubStep = mainStep.subSteps[subStepIndex - 1];
        previousSubStep.isSubBegin = true;
        previousSubStep.isSubComplete = false;
        previousSubStep.isSubUpComing = false;

        const currentSubStep = mainStep.subSteps[subStepIndex];
        currentSubStep.isSubBegin = false;
        currentSubStep.isSubComplete = false;
        currentSubStep.isSubUpComing = true;
      }
      // Set sub steps that come after the current one to upcoming
      for (let i = subStepIndex + 1; i < mainStep.subSteps.length; i++) {
        mainStep.subSteps[i].isSubBegin = false;
        mainStep.subSteps[i].isSubComplete = false;
        mainStep.subSteps[i].isSubUpComing = true;
      }

      return;
    }
  }
}

export function editButtonHandler(raSteps, mainStepIndex) {

  const mainStep = raSteps[mainStepIndex];

  if (mainStep !== -1) {
    mainStep.isBegin = true;
    mainStep.isComplete = false;
    mainStep.isUpComing = false;
    mainStep.isSubStepsOpen = true;

    mainStep.subSteps[0].isSubBegin = true;
    mainStep.subSteps[0].isSubComplete = false;
    mainStep.subSteps[0].isSubUpComing = false;

    for (let i = 1; i < mainStep.subSteps.length; i++) {
      mainStep.subSteps[i].isSubBegin = false;
      mainStep.subSteps[i].isSubComplete = false;
      mainStep.subSteps[i].isSubUpComing = true;
    }

    if (mainStepIndex === 3) {
      for (let i = mainStepIndex + 1; i < raSteps.length; i++) {
        const mainStep = raSteps[i];
        if (mainStep !== -1) {
          mainStep.isBegin = false;
          mainStep.isComplete = false;
          mainStep.isUpComing = true;
          mainStep.isSubStepsOpen = false;
        }
      }
    }
    return;
  }
}
